import { render, staticRenderFns } from "./PreServiceBills.vue?vue&type=template&id=637b2964&"
import script from "./PreServiceBills.vue?vue&type=script&lang=js&"
export * from "./PreServiceBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports